module.exports = function atan2 (y, x) {
  //  discuss at: http://locutus.io/php/atan2/
  // original by: Brett Zamir (http://brett-zamir.me)
  //   example 1: atan2(1, 1)
  //   returns 1: 0.7853981633974483

  return Math.atan2(y, x)
}
